import React, { useState, useEffect, lazy, Suspense } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Grid from "@material-ui/core/Grid";
import { useTheme } from '../../../ThemeContext';
import Breadcrumb from "../../Layouts/Breadcrumb";
import { Typography, Button, Card, Tabs, Tab, Box, Dialog, DialogTitle, DialogContent, TextField, Switch, Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import AuthCheckComponent from "../../Layouts/Token";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import ls from "local-storage";
import swal from "sweetalert";
import Swal from "sweetalert2";
// import Grid from "@material-ui/core/Grid";
// import Switch from '@material-ui/core/Switch';
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
// import * as GiIcons from "react-icons/gi";
// import * as AiIcons from "react-icons/ai";
// import * as BiIcons from "react-icons/bi";
// import * as RiIcons from "react-icons/ri";
// import * as CgIcons from "react-icons/cg";
// import * as BsIcons from "react-icons/bs";
// import * as FiIcons from "react-icons/fi";
// import * as IoIcons from "react-icons/io5";
// import * as HiIcons from "react-icons/hi";
// import * as GrIcons from "react-icons/gr";
// import * as DiIcons from "react-icons/di";
import Authapi from "../../Services/Authapi";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIcons } from '@fortawesome/free-solid-svg-icons';
import "./Settings.css"
import PageLoader from "../../Layouts/PageLoader";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";
import { saveLoginContentSettings, getLoginContentSettings } from "../../../utils/loginContentSettings";
import { getCalendarColorSettings, saveCalendarColorSettings, fetchAndSyncCalendarColors } from "../../../utils/calendarColorSettings";
//import "./user.css"

const notificationLabels = [
  "Leave Ticket", "Birthday", "Leave Status", "Upcoming Event", "Salary-Slip", "Time-Entry", "New Holiday", "Time-Entry Status", "Resign-Letter", "Task Update", "New Task", "Issue Activity", "Project Activity", "Milestone Activity"
];

const allIcons = {
  ...FaIcons,
  ...MdIcons,
  // ...GiIcons,
  // ...AiIcons,
  // ...BiIcons,
  // ...RiIcons,
  // ...CgIcons,
  // ...BsIcons,
  // ...FiIcons,
  // ...IoIcons,
  // ...HiIcons,
  // ...GrIcons,
  // ...DiIcons,
  // Add more icon packs here if needed
};

const IconPicker = lazy(() => import("./IconPicker"));

const Settings = (props) => {
  let darkMode = false;
  try {
    const theme = useTheme();
    darkMode = theme?.darkMode || false;
  } catch (e) {
    darkMode = false;
  }



  // console.log(props.authUser.user?.Break_notification_status)
  const classes = props;
  const [notificationIcons, setNotificationIcons] = useState({});
  // const [tabIndex, setTabIndex] = useState(0);
  // const [transparentSidebar, setTransparentSidebar] = useState(false);
  const [iconPickerOpen, setIconPickerOpen] = useState(false);
  const [currentLabel, setCurrentLabel] = useState("");
  const [loading, setLoading] = useState(true);
  const [updatedIcons, setUpdatedIcons] = useState({});
  const [fullDayHours, setFullDayHours] = useState("");
  const [halfDayHours, setHalfDayHours] = useState("");
  const [earlyLeaveMinHrs, setEarlyLeaveMinHrs] = useState("");
  const [earlyLeaveDays, setEarlyLeaveDays] = useState("");
  // COMMENT OUT leave balance state
  // const [lopLeaveBalance, setLopLeaveBalance] = useState("");
  // const [casualLeaveBalance, setCasualLeaveBalance] = useState("");
  // ADD carry forward expiry state
  const [carryForwardExpiryMonths, setCarryForwardExpiryMonths] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [lateThresholdTime, setLateThresholdTime] = useState("10:30:00");
  // const [switchState, setSwitchState] = useState(() => {
  //   const savedStatus = props.authUser.user?.Break_notification_status;
  //   // console.log(savedStatus)
  //   return savedStatus !== null ? savedStatus === 1 : props.authUser?.user?.Break_notification_status === 1;
  // });
  const storedPermissions = ls("userAccess");
  const permissions = (props.authUser && Array.isArray(props.authUser.userAccess))
    ? props.authUser.userAccess
    : Array.isArray(storedPermissions)
      ? storedPermissions
      : [];
  const [currentUserRole, setCurrentUserRole] = useState("");
  const normalizedRoles = (() => {
    const roleSources = [
      currentUserRole,
      ls("roles"),
      props.authUser?.user?.roleName,
      props.authUser?.user?.roles,
    ];

    return roleSources.flatMap((source) => {
      if (!source) {
        return [];
      }

      if (Array.isArray(source)) {
        return source.map((role) => {
          if (typeof role === "string") {
            return role.trim().toLowerCase();
          }

          return String(role?.name || "").trim().toLowerCase();
        }).filter(Boolean);
      }

      return String(source)
        .split(",")
        .map((role) => role.trim().toLowerCase())
        .filter(Boolean);
    });
  })();
  const transformLabel = (label) => {
    return label.replace(/_/g, " ");
  };

  const showLoadingPopup = (title = "Loading", text = "Please wait...") => {
    swal({
      title,
      text,
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });
  };

  const showSuccessPopup = (text, title = "Success") => swal({
    title,
    text,
    icon: "success",
    buttons: {
      confirm: {
        text: "OK",
        value: true,
        visible: true,
        className: "btn-success",
        closeModal: true,
      },
    },
    dangerMode: false,
  });

  const showErrorPopup = (text, title = "Error") => swal(title, text, "error");

  const settingsCardGradientBackground =
    "linear-gradient(160deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.08) 18%, rgba(255,255,255,0) 32%), linear-gradient(135deg, var(--hrms-primary-blue-start, #036dda) 0%, #236fc8 45%, var(--hrms-primary-blue-end, #036dda) 100%)";

  const settingsInfoCardStyle = {
    padding: "20px",
    background: settingsCardGradientBackground,
    color: "#fff",
    borderRadius: "15px",
    border: "1px solid rgba(148, 204, 255, 0.28)",
    boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
    width: "400px",
    minHeight: "190px",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
  };

  const settingsInfoCardDescriptionStyle = {
    opacity: 0.8,
    minHeight: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: 0,
  };

  const settingsInfoCardButtonRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "20px",
  };

  const [editMode, setEditMode] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reviewFormStatus, setReviewFormStatus] = useState({});
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
  const [editReviewMode, setEditReviewMode] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [statusColorsDialogOpen, setStatusColorsDialogOpen] = useState(false);
  const [statusColorsEditMode, setStatusColorsEditMode] = useState(false);
  const [calendarColorsDialogOpen, setCalendarColorsDialogOpen] = useState(false);
  const [calendarColorsEditMode, setCalendarColorsEditMode] = useState(false);
  const [calendarColors, setCalendarColors] = useState(getCalendarColorSettings());

  const handleCalendarColorChange = (key, value) => {
    setCalendarColors((prev) => ({ ...prev, [key]: value }));
  };

  const handleCalendarColorsSave = () => {
    saveCalendarColorSettings(calendarColors);
    showSuccessPopup("Calendar colors saved successfully!");
  };
  const [workingHoursAlertStatus, setWorkingHoursAlertStatus] = useState(null);
  const [whAlertStatusLoading, setWhAlertStatusLoading] = useState(true);
  const [userFullDayWH, setUserFullDayWH] = useState(7);
  const [userUpperWH, setUserUpperWH] = useState(8);
  const [userUpperWHMinute, setUserUpperWHMinute] = useState(0);
  const [whUserHoursDialogOpen, setWhUserHoursDialogOpen] = useState(false);
  const [whUserHoursEditMode, setWhUserHoursEditMode] = useState(false);
  const [editWhAlertStatus, setEditWhAlertStatus] = useState(workingHoursAlertStatus);

  const isLoginSettingsAllowed =
    normalizedRoles.includes("super admin") ||
    normalizedRoles.includes("admin") ||
    permissions.includes("Settings.LoginSettings");

  const [loginSettingsDialogOpen, setLoginSettingsDialogOpen] = useState(false);
  const [loginSettingsEditMode, setLoginSettingsEditMode] = useState(false);
  const [loginContentForm, setLoginContentForm] = useState({
    title: "",
    title2: "",
    quotes: "",
  });

  const [logoDialogOpen, setLogoDialogOpen] = useState(false);
  const [logoEditMode, setLogoEditMode] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");

  const handleOpenLoginSettingsDialog = (edit) => {
    Authapi.getLoginContent()
      .then((response) => {
        if (response && response.status && response.data) {
          setLoginContentForm({
            title: response.data.title || "",
            title2: response.data.title2 || "",
            quotes: response.data.quotes || "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching login content settings:", error);
      });
    setLoginSettingsEditMode(edit);
    setLoginSettingsDialogOpen(true);
  };

  const handleCloseLoginSettingsDialog = () => {
    setLoginSettingsDialogOpen(false);
    setLoginSettingsEditMode(false);
  };

  const handleLoginContentChange = (field, value) => {
    setLoginContentForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleLoginContentSave = async () => {
    Swal.fire({
      title: "Saving...",
      text: "Please wait while we save your changes.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const currentSettings = getLoginContentSettings();

    try {
      const response = await Authapi.saveLoginContent({
        title: loginContentForm.title,
        title2: loginContentForm.title2,
        quotes: loginContentForm.quotes,
        logo: currentSettings.logo,
      });

      Swal.close();

      if (response && response.status === true) {
        setLoginSettingsDialogOpen(false);
        setLoginSettingsEditMode(false);
        saveLoginContentSettings({
          ...loginContentForm,
          logo: currentSettings.logo,
        });
        showSuccessPopup("Login content saved successfully!");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to save login content settings.",
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Failed to save login content settings:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save login content settings.",
      });
    }
  };

  const handleOpenLogoDialog = (edit) => {
    Authapi.getLoginContent()
      .then((response) => {
        if (response && response.status && response.data) {
          setLogoUrl(response.data.logo || "");
        }
      })
      .catch((error) => {
        console.error("Error fetching logo settings:", error);
      });
    setLogoEditMode(edit);
    setLogoDialogOpen(true);
  };

  const handleCloseLogoDialog = () => {
    setLogoDialogOpen(false);
    setLogoEditMode(false);
  };

  const handleLogoUpload = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const postData = new FormData();
      postData.append("file", file);
      postData.append("is_logo", "1");

      Swal.fire({
        title: "Uploading logo...",
        text: "Please wait.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await Authapi.updateImg(postData);
        Swal.close();
        if (response && response.status === true && response.data?.image_url) {
          setLogoUrl(response.data.image_url);
        } else {
          showErrorPopup("Failed to upload logo.");
        }
      } catch (error) {
        Swal.close();
        showErrorPopup("Error uploading logo.");
      }
    }
  };

  const handleLogoSave = async () => {
    Swal.fire({
      title: "Saving...",
      text: "Please wait while we save your changes.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const currentSettings = getLoginContentSettings();

    try {
      const response = await Authapi.saveLoginContent({
        title: currentSettings.title,
        title2: currentSettings.title2,
        quotes: currentSettings.quotes,
        logo: logoUrl,
      });

      Swal.close();

      if (response && response.status === true) {
        setLogoDialogOpen(false);
        setLogoEditMode(false);
        saveLoginContentSettings({
          ...currentSettings,
          logo: logoUrl,
        });
        showSuccessPopup("Logo saved successfully!");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to save logo settings.",
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Failed to save logo settings:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save logo settings.",
      });
    }
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEditMode(false);
  };

  const fetchUserData = async () => {
    try {
      const response = await Authapi.getData();
      // console.log("API Response:", response); 

      const users = response.data || [];

      const filteredUsers = users
        .filter(user => user.user_logged === 1)
        .map(user => ({
          id: user.id,
          firstName: user.firstName,
          reviewFormStatus: user.Review_form_status === 1
        }));

      // console.log("Filtered Users:", filteredUsers); 

      setUserDetails(filteredUsers);
      setReviewFormStatus(filteredUsers.reduce((acc, user) => {
        acc[user.id] = user.reviewFormStatus;
        return acc;
      }, {}));
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleReviewStatusChange = async (userId, status) => {
    setReviewDialogOpen(false);
    try {
      showLoadingPopup("Updating...", "Please wait while we update the status.");

      const response = await Authapi.Reviewformstatus(userId, status ? 1 : 0);
      swal.close();

      if (response) {
        setReviewFormStatus((prevStatus) => ({
          ...prevStatus,
          [userId]: status,
        }));

        showSuccessPopup("Status updated successfully!").then(() => {
          setReviewDialogOpen(false);
        });
      } else {
        showErrorPopup("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating review form status:", error);
      swal.close();
      showErrorPopup("Failed to update status.");
    }
  };

  const statusList = [
    'Present',
    'Absent',
    'Half day',
    'Left Early',
    'Late',
    'Week Off',
    'Weekend Present',
    'Holiday',
    'Leave',
    'Overtime',
    'Short Hours',
  ];

  const defaultStatusColors = {
    'Present': '#1dbb11',
    'Absent': '#ff5c5c',
    'Half day': '#0f61cc',
    'Left Early': '#f7fa1e',
    'Late': '#dba775',
    'Week Off': '#3607df',
    'Weekend Present': '#ff8c42',
    'Holiday': '#9103dd',
    'Leave': '#3c343b',
    'Overtime': '#fb8c50',
    'Short Hours': '#c5bc34',
  };

  const [statusColors, setStatusColors] = useState({});
  const [statusColorsLoading, setStatusColorsLoading] = useState(true);
  const [statusColorsEdit, setStatusColorsEdit] = useState(false);

  useEffect(() => {
    const initialIcons = {};
    notificationLabels.forEach((label) => {
      initialIcons[label] = "FaFolderPlus";
    });

    Authapi.getNotificationIcons()
      .then((response) => {
        if (response) {

          const transformedResponse = {};
          for (const key in response) {
            transformedResponse[transformLabel(key)] = response[key];
          }
          setNotificationIcons((prevIcons) => ({
            ...initialIcons,
            ...transformedResponse,
          }));
        } else {
          setNotificationIcons(initialIcons);
        }
      })
      .catch((error) => {
        console.error("Error fetching notification icons:", error);
        setNotificationIcons(initialIcons);
      })
      .finally(() => {
        setLoading(false);
      });

      Authapi.getWorkingHours()
      .then((response) => {
        if (response && response.data) {
          setFullDayHours(response.data.full_day_hours);
          setHalfDayHours(response.data.half_day_hours);
          setEarlyLeaveMinHrs(response.data.early_leave_min_hours || "");
          setEarlyLeaveDays(response.data.early_leave_allowed_days || "");
          setLateThresholdTime(response.data.late_threshold_time || "10:30:00");
          setCarryForwardExpiryMonths(response.data.carry_forward_expiry_months || "");
        }
      })
      .catch((error) => {
        console.error("Error fetching working hours:", error);
      });
    // COMMENT OUT leave balance fetching
    // Authapi.getleavebalance()
    //   .then((response) => {
    //     if (response) {
    //       setCasualLeaveBalance(response.data.casual_leave_balance);
    //       setLopLeaveBalance(response.data.lop_leave_balance);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching leave balance:", error);
    //   });
    Authapi.breaktimeedit()
      .then((response) => {
        if (response) {
          setFromTime(response.data.do_not_disturb_from);
          setToTime(response.data.do_not_disturb_to);
        }
      })
      .catch((error) => {
        console.error("Error fetching leave balance:", error);
      });
    Authapi.getStatusColors().then((response) => {
      if (response && response.status && response.data) {
        const fetchedColors = response.data;
        // Migration: If 'Comes Late' exists but 'Late' does not, copy color
        if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
          fetchedColors['Late'] = fetchedColors['Comes Late'];
        }
        // Only use default if a status is missing in the response
        const mergedColors = { ...defaultStatusColors, ...fetchedColors };
        setStatusColors(mergedColors);
        if (fetchedColors.calendar_colors) {
          saveCalendarColorSettings(fetchedColors.calendar_colors);
          setCalendarColors(fetchedColors.calendar_colors);
        }
      } else {
        setStatusColors(defaultStatusColors);
      }
      setStatusColorsLoading(false);
    });
    fetchAndSyncCalendarColors().then((synced) => {
      if (synced) {
        setCalendarColors(synced);
      }
    });
    fetchUserData();
  }, []);

  // Fetch working hours alert status when user changes (or when component mounts)
  useEffect(() => {
    async function fetchWHAlertStatus() {
      setWhAlertStatusLoading(true);
      const userId = props.authUser.user?.id;
      if (userId) {
        const res = await Authapi.GetWorkingHoursAlertStatus(userId);
        if (res && res.status && typeof res.working_hours_alert_status === "boolean") {
          setWorkingHoursAlertStatus(res.working_hours_alert_status);
        }
        // Fetch user-specific working hours window for alert (full and upper hours)
        try {
          const hoursRes = await Authapi.getUserWorkingHours(userId);
          if (hoursRes && hoursRes.status) {
            if (typeof hoursRes.working_hours_full_day !== 'undefined') setUserFullDayWH(hoursRes.working_hours_full_day);
            if (typeof hoursRes.working_hours_upper_hour !== 'undefined') setUserUpperWH(hoursRes.working_hours_upper_hour);
            if (typeof hoursRes.working_hours_upper_minute !== 'undefined') setUserUpperWHMinute(hoursRes.working_hours_upper_minute);
          }
        } catch (e) {
          // noop
        }
      }
      setWhAlertStatusLoading(false);
    }
    fetchWHAlertStatus();
  }, [props.authUser.user?.id]);

  useEffect(() => {
    async function fetchCurrentRole() {
      const roleRes = await Authapi.fetchUserRole();
      if (roleRes && roleRes.role) {
        setCurrentUserRole(roleRes.role);
      }
    }

    fetchCurrentRole();
  }, []);

  const handleOpenWHUserHoursDialog = (edit) => {
    setWhUserHoursEditMode(!!edit);
    if (edit) {
      setEditWhAlertStatus(workingHoursAlertStatus);
      setUserFullDayWH(userFullDayWH); // keep or re-fetch as needed
      setUserUpperWH(userUpperWH);
    }
    setWhUserHoursDialogOpen(true);
  };

  const handleCloseWHUserHoursDialog = () => {
    setWhUserHoursDialogOpen(false);
    setWhUserHoursEditMode(false);
  };

  const handleSaveWHUserHours = async () => {
    const full = Number(userFullDayWH);
    const upper = Number(userUpperWH);
    if (!Number.isInteger(full) || !Number.isInteger(upper) || full < 1 || full > 24 || upper < 1 || upper > 24) {
      showErrorPopup('Hours must be integers between 1 and 24.');
      return;
    }
    if (upper <= full) {
      showErrorPopup('Upper hour must be greater than full day hour.');
      return;
    }
    showLoadingPopup("Saving...", "Please wait while we save your changes.");
    let hoursOk = false, statusOk = true;
    try {
      const userId = props.authUser.user?.id;
      // 1. Save hours (always)
      const res = await Authapi.setUserWorkingHours(userId, {
        working_hours_full_day: full,
        working_hours_upper_hour: upper,
      });
      hoursOk = !!(res && res.status);
      // 2. Save switch status (if changed)
      let statusRes = null;
      if (editWhAlertStatus !== workingHoursAlertStatus) {
        statusRes = await Authapi.WorkingHoursAlertStatus(userId, editWhAlertStatus ? 1 : 0);
        statusOk = !!(statusRes && statusRes.status);
        if (statusOk) setWorkingHoursAlertStatus(editWhAlertStatus);
      }
      swal.close();
      if (hoursOk && statusOk) {
        showSuccessPopup('Working hours and alert status updated.');
        handleCloseWHUserHoursDialog();
      } else if (!hoursOk) {
        showErrorPopup((res && res.message) ? res.message : 'Failed to update working hours.');
      } else if (!statusOk) {
        showErrorPopup((statusRes && statusRes.message) ? statusRes.message : 'Failed to update alert status.');
      }
    } catch (e) {
      swal.close();
      showErrorPopup('Failed to update working hours or alert status.');
    }
  };


  const handleIconChange = (iconKey) => {
    setNotificationIcons((prev) => ({
      ...prev,
      [currentLabel]: iconKey,
    }));
    setUpdatedIcons((prev) => ({
      ...prev,
      [currentLabel]: iconKey,
    }));
    setIconPickerOpen(false);
  };

  const handleSave = () => {
    showLoadingPopup("Saving...", "Please wait while we save your changes.");

    Authapi.saveNotificationIcons(updatedIcons)
      .then((response) => {
        swal.close();
        if (response) {
          showSuccessPopup("Icons saved successfully!").then(() => {
            props.history.push('/settings');
          });
          setUpdatedIcons({});
        } else {
          showErrorPopup("Error saving icons.");
        }
      })
      .catch((error) => {
        console.error("Error saving notification icons:", error);
        swal.close();
        showErrorPopup("Error saving notification icons.");
      });
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // const handleSidebarChange = (event) => {
  //   setTransparentSidebar(event.target.checked);
  // };

  const openIconPicker = (label) => {
    setCurrentLabel(label);
    setIconPickerOpen(true);
  };

  const handleWorkingHoursSave = async () => {
    showLoadingPopup("Saving...", "Please wait while we save your changes.");

    const hours = {
      fullDayHours,
      halfDayHours,
      earlyLeaveMinHrs,
      earlyLeaveDays,
      lateThresholdTime,
    };

    try {
      const response = await Authapi.saveWorkingHours(hours);
      swal.close();
      if (response) {
        showSuccessPopup("Working hours saved successfully!").then(() => {
          props.history.push('/settings');
        });
      } else {
        showErrorPopup("Failed to save working hours.");
      }
    } catch (error) {
      console.error("Failed to save working hours:", error);
      swal.close();
      showErrorPopup("Failed to save working hours.");
    }
  };


  // COMMENT OUT leave balance save handler
  // const handleLeaveSettingsSave = async () => {
  //   Swal.fire({
  //     title: "Saving...",
  //     text: "Please wait while we save your changes.",
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       Swal.showLoading();
  //     },
  //   });
  //   const leaveBalance = {
  //     casualLeaveBalance,
  //     lopLeaveBalance,
  //   };
  //   try {
  //     const response = await Authapi.saveleavebalance(leaveBalance);
  //     if (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Success",
  //         text: "Leave balances saved successfully!",
  //       }).then(() => {
  //         props.history.push('/Settings');
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: "Failed to save leave balances.",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Failed to save leave balances:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Failed to save leave balances.",
  //     });
  //   }
  // };
  // ADD carry forward expiry save handler
  const handleCarryForwardExpirySave = async () => {
    showLoadingPopup("Saving...", "Please wait while we save your changes.");
    try {
      const response = await Authapi.saveCarryForwardExpiry(carryForwardExpiryMonths);
      swal.close();
      if (response && response.status) {
        showSuccessPopup("Carry forward expiry period saved successfully!").then(() => {
          setDialogOpen(false);
          setEditMode(false);
        });
      } else {
        showErrorPopup(response && response.message ? response.message : "Failed to save expiry period.");
      }
    } catch (error) {
      swal.close();
      showErrorPopup("Failed to save expiry period.");
    }
  };

  const handleReminderTimeSave = async () => {
    showLoadingPopup("Saving...", "Please wait while we save your changes.");

    try {
      const response = await Authapi.breaktimeadd({ fromTime, toTime });
      swal.close();
      if (response && response.status === true) {
        showSuccessPopup("Reminder times saved successfully!").then(() => {
          props.history.push('/settings');
        });
      } else {
        showErrorPopup("Failed to save reminder times.");
      }
    } catch (error) {
      swal.close();
      showErrorPopup("Something went wrong, Please try later!");
      console.error("Error saving reminder times:", error);
    }
  };
  const statusRow = async (id, status) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      showLoadingPopup();
      try {
        let statu = await Authapi.BreakNotificationStatus(id, status);
        swal.close();
        if (statu && statu.status === true) {
          if (props.userData) {
            await props.userData();
          }
          window.location.reload();
        }
      } catch (error) {
        swal.close();
        console.error('Error updating user status:', error);
        swal("Error", "Failed to update notification status", "error");
      }
    }
  }

  const statusRowWorkingHours = async (id, status) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      showLoadingPopup();
      try {
        let statu = await Authapi.WorkingHoursAlertStatus(id, status);
        swal.close();
        if (statu && statu.status === true) {
          if (props.userData) {
            await props.userData();
          }
          window.location.reload();
        }
      } catch (error) {
        swal.close();
        console.error('Error updating working hours alert status:', error);
        swal("Error", "Failed to update working hours alert status", "error");
      }
    }
  }

  const handleStatusColorChange = (status, color) => {
    setStatusColors((prev) => ({ ...prev, [status]: color }));
  };

  const handleStatusColorsSave = async () => {
    setStatusColorsLoading(true);
    showLoadingPopup("Saving...", "Please wait while we save your changes.");

    try {
      const response = await Authapi.updateStatusColors(statusColors);
      swal.close();
      if (response && response.status) {
        showSuccessPopup('Status colors saved successfully!');
        setStatusColorsEdit(false);
      } else {
        showErrorPopup('Failed to save status colors.');
      }
    } catch (error) {
      swal.close();
      showErrorPopup('Failed to save status colors.');
    } finally {
      setStatusColorsLoading(false);
    }
  };

  const availableTabs = [
    { permission: "Settings.ReminderSettingsView", index: 0 },
    { permission: "Settings.WorkingHoursView", index: 1 },
    { permission: "Settings.LeaveSettingsView", index: 2 },
    { permission: "Settings.NotificationsView", index: 3 },
    { permission: "Settings.ReviewFormSettingsView", index: 4 },
    { permission: "Settings.Attendance", index: 5 },
    { permission: "Settings.LoginSettings", index: 6 },
  ];

  const defaultTabIndex = availableTabs.find(tab => 
    permissions.includes(tab.permission) || 
    (tab.permission === "Settings.LoginSettings" && isLoginSettingsAllowed)
  )?.index || 0;
  const [tabIndex, setTabIndex] = useState(defaultTabIndex);

  useEffect(() => {
    const isCurrentTabAvailable = availableTabs.some((tab) =>
      tab.index === tabIndex &&
      (
        permissions.includes(tab.permission) ||
        (tab.permission === "Settings.LoginSettings" && isLoginSettingsAllowed)
      )
    );

    if (!isCurrentTabAvailable) {
      setTabIndex(defaultTabIndex);
    }
  }, [tabIndex, defaultTabIndex, permissions, isLoginSettingsAllowed]);

  // Function to format time to 12-hour format
  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours, minutes);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  if (loading) {
    return (
      <div>
        <AuthCheckComponent authToken={props.authToken} />
        <Header {...props} authUser={props.authUser} component={<PageLoader />} />
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <div className="settings-breadcrumb-card">
                <Breadcrumb
                  {...props}
                  primaryPageName="Settings"
                  primaryPageLink="/settings"
                />
            </div>
            <Grid container className={classes.root} spacing={2}>
              <div style={{ padding: "20px", width: "100%" }}>
                <Tabs
                  value={tabIndex}
                  onChange={handleTabChange}
                  aria-label="settings tabs"
                  sx={{
                    '& .MuiTabs-flexContainer': {
                      flexWrap: 'wrap',
                    },
                    '& .MuiTabs-scroller': {
                      height: 'auto !important',
                      overflow: 'visible !important',
                    },
                    '& .MuiTabs-indicator': {
                      display: 'none',
                    },
                    '& .MuiTab-root': {
                      borderBottom: '2px solid transparent',
                    },
                    '& .MuiTab-root.Mui-selected': {
                      borderBottom: '2px solid var(--hrms-primary-blue-start, #036dda)',
                      color: 'var(--hrms-primary-blue-start, #036dda) !important',
                    },
                  }}
                >
                  {permissions.includes("Settings.ReminderSettingsView") && (
                    <Tab label="Break Time Settings" value={0} />
                  )}
                  {permissions.includes("Settings.WorkingHoursView") && (
                    <Tab label="Working Hours" value={1} />
                  )}
                  {permissions.includes("Settings.LeaveSettingsView") && (
                    <Tab label="Leaves Settings" value={2} />
                  )}
                  {permissions.includes("Settings.NotificationsView") && (
                    <Tab label="Notifications" value={3} />
                  )}
                  {permissions.includes("Settings.ReviewFormSettingsView") && (
                    <Tab label="Review Form Settings" value={4} />
                  )}
                  {permissions.includes("Settings.Attendance") && (
                    <Tab label=" Attendance" value={5} />
                  )}
                  {isLoginSettingsAllowed && (
                    <Tab label="Login" value={6} />
                  )}



                </Tabs>

                {permissions.includes("Settings.ReminderSettingsView") && (
                  <TabPanel value={tabIndex} index={0}>
                    <Grid container spacing={2} style={{ justifyContent: 'flex-start' }}>
                      <Grid item>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Break Time Settings
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Here you can set the break times.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                              <Button
                                variant="contained"
                                onClick={() => setDialogOpen(true)}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaClock style={{ marginRight: "5px" }} />
                                See times
                              </Button>
                              <Button
                                variant="contained"
                                onClick={toggleEditMode}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                      <Grid item>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Break Notification Settings
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Toggle break time notifications.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '18px' }}>
                              <Typography variant="body1">
                                Break time notification status :
                              </Typography>
                              <Tooltip title="Toggle break notifications">
                                <label style={{ display: 'inline-block', position: 'relative', cursor: 'pointer' }}>
                                  <input
                                    type="checkbox"
                                    className="happy-warthog-checkbox"
                                    checked={!!props.authUser.user?.Break_notification_status}
                                    onChange={() => statusRow(props.authUser.user?.id, props.authUser.user?.Break_notification_status ? 0 : 1)}
                                    aria-label="break notification switch"
                                  />
                                  <div className="happy-warthog-slider"></div>
                                </label>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>


                    </Grid>

                    <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {editMode ? "Edit Break Times" : "Current Break Times"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleDialogClose}
                      />
                      <DialogContent className="settings-dialog-content" style={{ display: "flex", justifyContent: "space-around" }}>
                        {editMode ? (
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="time"
                                size="small"
                                variant="outlined"
                                value={fromTime}
                                onChange={(e) => setFromTime(e.target.value)}
                                label="From Time"
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="time"
                                size="small"
                                variant="outlined"
                                value={toTime}
                                onChange={(e) => setToTime(e.target.value)}
                                label="To Time"
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <div className="settings-dialog-actions">
                              <Button
                                className="btn-success"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleDialogClose();
                                  handleReminderTimeSave();
                                }}
                                style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}
                              >
                                Save
                              </Button>
                              <Button
                                className="btn-cancel"
                                onClick={handleDialogClose}
                                style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                              >
                                Cancel
                              </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : (
                          <TableContainer component={Paper} elevation={0}>
                            <Table size="small">
                              <TableHead>
                                <TableRow style={{ backgroundColor: '#036dda' }}>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>From Time</TableCell>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>To Time</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell style={{ textAlign: 'center' }}>{formatTime(fromTime)}</TableCell>
                                  <TableCell style={{ textAlign: 'center' }}>{formatTime(toTime)}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                )}

                {permissions.includes("Settings.WorkingHoursView") && (
                  <TabPanel value={tabIndex} index={1}>
                    <Grid container style={{ justifyContent: 'flex-start', }} spacing={2}>
                      <Grid item>
                        <Card
                          style={settingsInfoCardStyle}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Working Hours Settings
                          </Typography>
                          <Typography variant="body1" style={settingsInfoCardDescriptionStyle}>
                            Here you can set the half day and full day hours and late comes time.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={settingsInfoCardButtonRowStyle}>
                              <Button
                                variant="contained"
                                onClick={() => setDialogOpen(true)}
                                className="settings-card-view-button"
                              >
                                <MdIcons.MdTimer style={{ marginRight: "5px" }} />
                                See hours
                              </Button>
                              <Button
                                variant="contained"
                                onClick={toggleEditMode}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="md" PaperProps={{ className: "settings-dialog-paper" }}>
                        <DialogTitle className="settings-dialog-title">{editMode ? "Edit Working Hours" : "Current Working Hours"}</DialogTitle>
                        <CloseIcon
                          className="settings-dialog-close"
                          onClick={handleDialogClose}
                        />
                        <DialogContent className="settings-dialog-content" style={{ display: "flex", justifyContent: "space-around" }}>
                          {editMode ? (
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  value={fullDayHours}
                                  onChange={(e) => setFullDayHours(e.target.value)}
                                  label="Min Full-Day Hours"
                                  style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  value={halfDayHours}
                                  onChange={(e) => setHalfDayHours(e.target.value)}
                                  label="Min Half-Day Hours"
                                  style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  value={earlyLeaveDays}
                                  onChange={(e) => setEarlyLeaveDays(e.target.value)}
                                  label="Early leave allowed number of days"
                                  style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  value={earlyLeaveMinHrs}
                                  onChange={(e) => setEarlyLeaveMinHrs(e.target.value)}
                                  label="Early Leave Min. Hrs."
                                  style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  type="time"
                                  value={lateThresholdTime}
                                  onChange={(e) => setLateThresholdTime(e.target.value)}
                                  label="Late Comes Time"
                                  style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{ step: 1 }}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <div className="settings-dialog-actions">
                                <Button
                                  className="btn-success"
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    handleDialogClose();
                                    handleWorkingHoursSave();
                                  }}
                                  style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}
                                >
                                  Save
                                </Button>
                                <Button
                                  className="btn-cancel"
                                  onClick={handleDialogClose}
                                  style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                                >
                                  Cancel
                                </Button>
                                </div>
                              </Grid>
                            </Grid>
                          ) : (
                            <TableContainer component={Paper} elevation={0}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow style={{ backgroundColor: '#036dda' }}>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Full Day Hours</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Half Day Hours</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Early Leave Allowed Days</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Early Leave Min. Hrs</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Late Comes Time</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell style={{ textAlign: 'center' }}>{fullDayHours}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{halfDayHours}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{earlyLeaveDays}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{earlyLeaveMinHrs}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{formatTime(lateThresholdTime)}</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                        </DialogContent>
                      </Dialog>



                      <Grid item>
                        <Card
                          style={settingsInfoCardStyle}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Working Hours Alert
                          </Typography>
                          <Typography variant="body1" style={settingsInfoCardDescriptionStyle}>
                            Working hours alert and set your alert hours.
                          </Typography>

                          <Grid container spacing={2}>
                            {/* Working hours alert toggle (commented out) */}
                            {/* <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '18px' }}>
        <Typography variant="body1">
          Working hours alert status :
        </Typography>
        {whAlertStatusLoading ? (
          <span style={{ marginLeft: 8 }}>Loading...</span>
        ) : (
          <span
            style={{
              marginLeft: 8,
              fontWeight: 'bold',
              color: workingHoursAlertStatus ? 'lightgreen' : '#ff7878',
            }}
          >
            {workingHoursAlertStatus ? 'ON' : 'OFF'}
          </span>
        )}
        <Tooltip title="Toggle working hours alert">
          <Switch
            checked={!!workingHoursAlertStatus}
            onChange={async () => {
              const userId = props.authUser.user?.id;
              const newStatus = !workingHoursAlertStatus;
              setWhAlertStatusLoading(true);
              const res = await Authapi.WorkingHoursAlertStatus(userId, newStatus ? 1 : 0);
              if (res && res.status) setWorkingHoursAlertStatus(newStatus);
              setWhAlertStatusLoading(false);
            }}
            color="primary"
            inputProps={{ 'aria-label': 'working hours alert switch' }}
            disabled={whAlertStatusLoading}
          />
        </Tooltip>
      </Grid> */}

                            {/* Buttons Row */}
                            <Grid
                              item
                              xs={12}
                              style={settingsInfoCardButtonRowStyle}
                            >
                              <Button
                                variant="contained"
                                onClick={() => handleOpenWHUserHoursDialog(false)}
                                className="settings-card-view-button"
                              >
                                <MdIcons.MdTimer style={{ marginRight: "5px" }} />
                                See Hours
                              </Button>

                              <Button
                                variant="contained"
                                onClick={() => handleOpenWHUserHoursDialog(true)}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                      <Grid item>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Calendar Event Colors
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Set custom colors for calendar event categories & leave statuses.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                              <Button
                                variant="contained"
                                onClick={() => { setCalendarColorsDialogOpen(true); setCalendarColorsEditMode(false); }}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaPalette style={{ marginRight: "5px" }} />
                                See Colors
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => { setCalendarColorsDialogOpen(true); setCalendarColorsEditMode(true); }}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                    </Grid>

                    <Dialog open={statusColorsDialogOpen} onClose={() => setStatusColorsDialogOpen(false)} fullWidth maxWidth="md" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {statusColorsEditMode ? "Edit Status Colors" : "Current Status Colors"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={() => setStatusColorsDialogOpen(false)}
                      />
                      <DialogContent className="settings-dialog-content" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {statusColorsLoading ? (
                          <Typography>Loading...</Typography>
                        ) : (
                          <Grid container spacing={2}>
                            {statusList.map((status) => (
                              <Grid item xs={6} key={status}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                  <span style={{ width: 110 }}>{status}</span>
                                  <input
                                    type="color"
                                    value={statusColors[status] || '#000000'}
                                    disabled={!statusColorsEditMode}
                                    onChange={e => handleStatusColorChange(status, e.target.value)}
                                    style={{ marginLeft: 10, marginRight: 10, width: 40, height: 30, border: 'none', background: 'none' }}
                                  />
                                  <span style={{ color: darkMode ? "#ffffff" : "#000000", fontWeight: 'bold', marginLeft: 10 }}>{statusColors[status]}</span>
                                </div>
                              </Grid>
                            ))}
                            <Grid item xs={12}>
                              {statusColorsEditMode ? (
                                <div className="settings-dialog-actions">
                                  <Button className="btn-success" variant="contained" color="primary" onClick={async () => { await handleStatusColorsSave(); setStatusColorsDialogOpen(false); }} style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}>Save</Button>
                                  <Button
                                    className="btn-cancel"
                                    onClick={() => setStatusColorsDialogOpen(false)}
                                    style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              ) : null}
                            </Grid>
                          </Grid>
                        )}
                      </DialogContent>
                    </Dialog>

                    <Dialog open={whUserHoursDialogOpen} onClose={handleCloseWHUserHoursDialog} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {whUserHoursEditMode ? "Edit Working Hours Alert Window" : "Current Working Hours Alert Window"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleCloseWHUserHoursDialog}
                      />
                      <DialogContent
                        className="settings-dialog-content"
                        style={{ display: "flex", justifyContent: "space-around" }}
                      >
                        {whUserHoursEditMode ? (
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Typography variant="body1">Working hours alert status :</Typography>
                              <Tooltip title="Toggle working hours alert">
                                <label style={{ display: 'inline-block', position: 'relative', cursor: 'pointer', marginLeft: 16 }}>
                                  <input
                                    type="checkbox"
                                    className="happy-warthog-checkbox"
                                    checked={!!editWhAlertStatus}
                                    onChange={() => setEditWhAlertStatus(!editWhAlertStatus)}
                                    aria-label="working hours alert switch"
                                  />
                                  <div className="happy-warthog-slider"></div>
                                </label>
                              </Tooltip>
                              <Typography sx={{ ml: 2, fontWeight: 'bold', color: editWhAlertStatus ? 'green' : '#888' }}>
                                {editWhAlertStatus ? 'ON' : 'OFF'}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                variant="outlined"
                                value={userFullDayWH}
                                onChange={(e) => setUserFullDayWH(e.target.value)}
                                label="Full Day Hours"
                                inputProps={{ min: 1, max: 24 }}
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                variant="outlined"
                                value={userUpperWH}
                                onChange={(e) => setUserUpperWH(e.target.value)}
                                label="Upper Hour"
                                inputProps={{ min: 1, max: 24 }}
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <div className="settings-dialog-actions">
                              <Button
                                className="btn-success"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleCloseWHUserHoursDialog();
                                  handleSaveWHUserHours();
                                }}
                                style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}
                              >
                                Save
                              </Button>
                              <Button
                                className="btn-cancel"
                                onClick={handleCloseWHUserHoursDialog}
                                style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                              >
                                Cancel
                              </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : (
                          <TableContainer component={Paper} elevation={0}>
                            <Table size="small">
                              <TableHead>
                                <TableRow style={{ backgroundColor: '#036dda' }}>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Alert Status</TableCell>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Full Day Hours</TableCell>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center', color: '#fff' }}>Upper Hour</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: workingHoursAlertStatus ? 'green' : 'red' }}>
                                    {workingHoursAlertStatus ? 'ON' : 'OFF'}
                                  </TableCell>
                                  <TableCell style={{ textAlign: 'center' }}>{userFullDayWH}</TableCell>
                                  <TableCell style={{ textAlign: 'center' }}>{userUpperWH}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </DialogContent>
                    </Dialog>

                  </TabPanel>
                )}

                {permissions.includes("Settings.LeaveSettingsView") && (
                  <TabPanel value={tabIndex} index={2}>
                    <Grid container style={{ display: "grid", justifyContent: 'flex-start' }}>
                      <Card
                        style={{
                          padding: "20px",
                          background: settingsCardGradientBackground,
                          color: "#fff",
                          borderRadius: "15px",
                          border: "1px solid rgba(148, 204, 255, 0.28)",
                          boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                          width: "400px",
                          margin: "auto",
                        }}
                      >
                        <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                          Carry Forward Leave Settings
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                          Here you can set the carry forward leave balance expiry period (in months).
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                            <Button
                              variant="contained"
                              onClick={() => setDialogOpen(true)}
                              style={{ backgroundColor: "white", color: "black", fontWeight: "bold" }}
                            >
                              <FaIcons.FaTicketAlt style={{ marginRight: "5px" }} />
                              See expiry period
                            </Button>
                            <Button
                              variant="contained"
                              className="settings-card-edit-button preserve-button-theme"
                              onClick={toggleEditMode}
                            >
                              <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                              Edit
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {editMode ? "Edit Carry Forward Expiry" : "Current Carry Forward Expiry"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleDialogClose}
                      />
                      <DialogContent className="settings-dialog-content" style={{ display: "flex", justifyContent: "space-around" }}>
                        {editMode ? (
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={carryForwardExpiryMonths}
                                onChange={(e) => setCarryForwardExpiryMonths(e.target.value)}
                                label="Carry Forward Expiry (months)"
                                type="number"
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <div className="settings-dialog-actions">
                              <Button
                                className="btn-success"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleDialogClose();
                                  handleCarryForwardExpirySave();
                                }}
                                style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}
                              >
                                Save
                              </Button>
                              <Button
                                className="btn-cancel"
                                onClick={handleDialogClose}
                                style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                              >
                                Cancel
                              </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : (
                          <TableContainer component={Paper} elevation={0}>
                            <Table size="small">
                              <TableHead>
                                <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                  <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>Carry Forward Expiry (months)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell style={{ textAlign: 'center' }}>{carryForwardExpiryMonths}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </DialogContent>
                    </Dialog>
                    {/* COMMENT OUT old leave balance UI
                    <Dialog open={dialogOpen} onClose={handleDialogClose}>
                      <DialogTitle
                        style={{ backgroundColor: "#036dda", color: "white", fontWeight: "bold", padding: "5px" }}>
                        {editMode ? "Edit Leave Balances" : "Current Leave Balances"}
                      </DialogTitle>
                      <CloseIcon
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          cursor: "pointer",
                          color: "#fff",
                          backgroundColor: "#f44336",
                          borderRadius: "50%",
                          padding: "2px",
                        }}
                        onClick={handleDialogClose}
                      />
                      <DialogContent
                        style={{
                          paddingTop: "20px",
                          display: "flex",
                          justifyContent: "space-around",
                        }}>
                        {editMode ? (
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={lopLeaveBalance}
                                onChange={(e) => setLopLeaveBalance(e.target.value)}
                                label="Loss of Pay Leave Balance"
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={casualLeaveBalance}
                                onChange={(e) => setCasualLeaveBalance(e.target.value)}
                                label="Casual Leave Balance"
                                style={{ backgroundColor: "#fafafa", marginBottom: "10px" }}
                              />
                            </Grid>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleDialogClose();
                                  handleLeaveSettingsSave();
                                }}
                                style={{ backgroundColor: "#036dda", color: "#fff", fontWeight: "bold", marginRight: "6px" }}
                              >
                                Save
                              </Button>
                              <Button
                                onClick={handleDialogClose}
                                style={{ color: "#000000" }}
                              >
                                Cancel
                              </Button>
                            </Grid>
                          </Grid>
                        ) : (
                          <>
                            <Typography variant="body1">
                              Loss of Pay Leave Balance: {lopLeaveBalance}
                            </Typography>
                            <Typography variant="body1">
                              Casual Leave Balance: {casualLeaveBalance}
                            </Typography>
                          </>
                        )}
                      </DialogContent>
                    </Dialog>
                    */}
                  </TabPanel>
                )}

                {permissions.includes("Settings.NotificationsView") && (
                  <TabPanel value={tabIndex} index={3}>
                    <Grid container style={{ display: "grid", justifyContent: 'flex-start' }}>
                      <Card
                        style={{
                          padding: "20px",
                          background: settingsCardGradientBackground,
                          color: "#fff",
                          borderRadius: "15px",
                          border: "1px solid rgba(148, 204, 255, 0.28)",
                          boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                          width: "400px",
                          margin: "auto",
                        }}
                      >
                        <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                          Notification Icons
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                          Here you can set the notification icons.
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                            <Button
                              variant="contained"
                              onClick={() => setDialogOpen(true)}
                              style={{ backgroundColor: "white", color: "black", fontWeight: "bold" }}
                            >
                              <FontAwesomeIcon icon={faIcons} style={{ marginRight: "5px" }} />
                              See Icons
                            </Button>
                            <Button
                              variant="contained"
                              className="settings-card-edit-button preserve-button-theme"
                              onClick={toggleEditMode}
                            >
                              <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                              Edit
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>

                    <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="md" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {editMode ? "Edit Notification Icons" : "Current Notification Icons"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleDialogClose}
                      />
                      <DialogContent className="settings-dialog-content" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {editMode ? (
                          <Grid container spacing={2}>
                            {notificationLabels.map((label) => (
                              <Grid item xs={6} key={label}>
                                <Card
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px",
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: "10px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <Typography variant="body1">{label}</Typography>
                                  <Button
                                    className="settings-icon-trigger"
                                    onClick={() => openIconPicker(label)}
                                  >
                                    {allIcons[notificationIcons[label]]
                                      ? React.createElement(
                                        allIcons[notificationIcons[label]],
                                        { size: 24, color: "#ffffff" }
                                      )
                                      : React.createElement(
                                        allIcons["FaFolderPlus"],
                                        { size: 24, color: "#ffffff" }
                                      )}
                                  </Button>
                                </Card>
                              </Grid>
                            ))}
                            <Grid item xs={12}>
                              <div className="settings-dialog-actions">
                              <Button
                                className="btn-success"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  handleDialogClose();
                                  handleSave();
                                }}
                                style={{ backgroundColor: "#036dda", color: "#fff", textTransform: 'none' }}
                              >
                                Save
                              </Button>
                              <Button
                                className="btn-cancel"
                                onClick={handleDialogClose}
                                style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                              >
                                Cancel
                              </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container spacing={2}>
                            {notificationLabels.map((label) => (
                              <Grid item xs={6} key={label}>
                                <Card
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px",
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: "10px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <Typography variant="body1">{label}</Typography>
                                  <Button className="settings-icon-trigger">
                                    {allIcons[notificationIcons[label]]
                                      ? React.createElement(
                                        allIcons[notificationIcons[label]],
                                        { size: 24, color: "#ffffff" }
                                      )
                                      : React.createElement(
                                        allIcons["FaFolderPlus"],
                                        { size: 24, color: "#ffffff" }
                                      )}
                                  </Button>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        )}
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                )}

                {permissions.includes("Settings.ReviewFormSettingsView") && (
                  <TabPanel value={tabIndex} index={4}>
                    <Grid container spacing={2} style={{ justifyContent: 'flex-start' }}>
                      <Grid item>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Review Form Settings
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Manage review form status for each user.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                              <Button
                                variant="contained"
                                onClick={() => { setReviewDialogOpen(true); setEditReviewMode(false); }}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaEye style={{ marginRight: "5px" }} />
                                See Status
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => { setReviewDialogOpen(true); setEditReviewMode(true); }}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>

                    <Dialog open={reviewDialogOpen} onClose={() => setReviewDialogOpen(false)}>
                      <DialogTitle className="settings-dialog-title">
                        {editReviewMode ? "Edit Review Form Status" : "Current Review Form Status"}
                      </DialogTitle>
                      <CloseIcon className="settings-dialog-close" onClick={() => setReviewDialogOpen(false)} />
                      <DialogContent
                        style={{
                          paddingTop: "20px",
                          display: "flex",
                          flexDirection: "row", // Arrange users side by side
                          flexWrap: "wrap",
                          justifyContent: "center",
                        }}>
                        <Grid container spacing={2}>
                          {userDetails.map((user) => (
                            <Grid item xs={6} key={user.id}>
                              <Card
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "10px",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "10px",
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                <Typography variant="body1">{user.firstName}</Typography>
                                <label style={{ display: 'inline-block', position: 'relative', cursor: !editReviewMode ? 'not-allowed' : 'pointer', opacity: !editReviewMode ? 0.6 : 1 }}>
                                  <input
                                    type="checkbox"
                                    className="happy-warthog-checkbox"
                                    checked={!!reviewFormStatus[user.id]}
                                    onChange={() => editReviewMode && handleReviewStatusChange(user.id, !reviewFormStatus[user.id])}
                                    aria-label="review form status switch"
                                    disabled={!editReviewMode}
                                  />
                                  <div className="happy-warthog-slider"></div>
                                </label>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                )}


                {permissions.includes("Settings.Attendance") && (
                  <TabPanel value={tabIndex} index={5}>
                    <Grid container style={{ justifyContent: 'flex-start', }} spacing={2}>


                      <Grid item>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            margin: "auto",
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Attendance Status Colors
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Set the color for each attendance status.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "44px" }}>
                              <Button
                                variant="contained"
                                onClick={() => { setStatusColorsDialogOpen(true); setStatusColorsEditMode(false); }}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaPalette style={{ marginRight: "5px" }} />
                                See Colors
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => { setStatusColorsDialogOpen(true); setStatusColorsEditMode(true); }}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>







                    </Grid>

                    <Dialog open={statusColorsDialogOpen} onClose={() => setStatusColorsDialogOpen(false)}>
                      <DialogTitle className="settings-dialog-title">
                        {statusColorsEditMode ? "Edit Status Colors" : "Current Status Colors"}
                      </DialogTitle>
                      <CloseIcon className="settings-dialog-close" onClick={() => setStatusColorsDialogOpen(false)} />
                      <DialogContent style={{ paddingTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {statusColorsLoading ? (
                          <Typography>Loading...</Typography>
                        ) : (
                          <Grid container spacing={2}>
                            {statusList.map((status) => (
                              <Grid item xs={6} key={status}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                  <span style={{ width: 110 }}>{status}</span>
                                  <input
                                    type="color"
                                    value={statusColors[status] || '#000000'}
                                    disabled={!statusColorsEditMode}
                                    onChange={e => handleStatusColorChange(status, e.target.value)}
                                    style={{ marginLeft: 10, marginRight: 10, width: 40, height: 30, border: 'none', background: 'none' }}
                                  />
                                  <span style={{ color: darkMode ? (['#000000', '#212121'].includes(statusColors[status]?.toLowerCase()) ? '#ffffff' : (statusColors[status] || '#ffffff')) : (['#ffffff', '#ededed', '#f5f5f5'].includes(statusColors[status]?.toLowerCase()) ? '#000000' : (statusColors[status] || '#000000')), fontWeight: 'bold', marginLeft: 10 }}>{statusColors[status]}</span>
                                </div>
                              </Grid>
                            ))}
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                              {statusColorsEditMode ? (
                                <div className="settings-dialog-actions">
                                  <Button className="btn-success" variant="contained" color="primary" onClick={async () => { await handleStatusColorsSave(); setStatusColorsDialogOpen(false); }} style={{ textTransform: 'none' }}>Save</Button>
                                  <Button
                                    className="btn-cancel"
                                    onClick={() => setStatusColorsDialogOpen(false)}
                                    style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              ) : null}
                            </Grid>
                          </Grid>
                        )}
                      </DialogContent>
                    </Dialog>

                    <Dialog open={whUserHoursDialogOpen} onClose={handleCloseWHUserHoursDialog} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {whUserHoursEditMode ? "Edit Working Hours Alert Window" : "Current Working Hours Alert Window"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleCloseWHUserHoursDialog}
                      />

                    </Dialog>
                  </TabPanel>
                )}

                {isLoginSettingsAllowed && (
                  <TabPanel value={tabIndex} index={6}>
                    <Grid container spacing={2} style={{ justifyContent: 'flex-start', alignItems: 'stretch' }}>
                      <Grid item style={{ display: 'flex' }}>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            minHeight: "190px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Login
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Manage the dynamic titles and quotes shown on the login page.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                              <Button
                                variant="contained"
                                onClick={() => handleOpenLoginSettingsDialog(false)}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaEye style={{ marginRight: "5px" }} />
                                View
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => handleOpenLoginSettingsDialog(true)}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                      <Grid item style={{ display: 'flex' }}>
                        <Card
                          style={{
                            padding: "20px",
                            background: settingsCardGradientBackground,
                            color: "#fff",
                            borderRadius: "15px",
                            border: "1px solid rgba(148, 204, 255, 0.28)",
                            boxShadow: "0 16px 32px rgba(5, 23, 52, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                            width: "400px",
                            minHeight: "190px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
                            Logo
                          </Typography>
                          <Typography variant="body1" gutterBottom style={{ opacity: 0.8 }}>
                            Manage the dynamic logo shown on the sidebar.
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                              <Button
                                variant="contained"
                                onClick={() => handleOpenLogoDialog(false)}
                                className="settings-card-view-button"
                              >
                                <FaIcons.FaEye style={{ marginRight: "5px" }} />
                                View
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => handleOpenLogoDialog(true)}
                                className="settings-card-edit-button"
                              >
                                <MdIcons.MdEdit style={{ marginRight: "5px" }} />
                                Edit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>

                    <Dialog open={loginSettingsDialogOpen} onClose={handleCloseLoginSettingsDialog} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {loginSettingsEditMode ? "Edit Login" : "View Login"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleCloseLoginSettingsDialog}
                      />
                      <DialogContent className="settings-dialog-content">
                        <TextField
                          fullWidth
                          margin="normal"
                          label="Title"
                          value={loginContentForm.title || ""}
                          onChange={(e) => handleLoginContentChange("title", e.target.value)}
                          disabled={!loginSettingsEditMode}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#000000 !important",
                              WebkitTextFillColor: darkMode ? "#ffffff !important" : "#000000 !important",
                            },
                            "& label.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#666666 !important",
                              opacity: "1 !important",
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4)" : "rgba(0, 0, 0, 0.23)",
                            },
                            "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : "rgba(0, 0, 0, 0.23) !important",
                            }
                          }}
                        />
                        <TextField
                          fullWidth
                          margin="normal"
                          label="Title 2"
                          value={loginContentForm.title2 || ""}
                          onChange={(e) => handleLoginContentChange("title2", e.target.value)}
                          disabled={!loginSettingsEditMode}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#000000 !important",
                              WebkitTextFillColor: darkMode ? "#ffffff !important" : "#000000 !important",
                            },
                            "& label.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#666666 !important",
                              opacity: "1 !important",
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4)" : "rgba(0, 0, 0, 0.23)",
                            },
                            "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : "rgba(0, 0, 0, 0.23) !important",
                            }
                          }}
                        />
                        <TextField
                          fullWidth
                          margin="normal"
                          label="Quotes"
                          multiline
                          rows={3}
                          value={loginContentForm.quotes || ""}
                          onChange={(e) => handleLoginContentChange("quotes", e.target.value)}
                          disabled={!loginSettingsEditMode}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#000000 !important",
                              WebkitTextFillColor: darkMode ? "#ffffff !important" : "#000000 !important",
                            },
                            "& label.Mui-disabled": {
                              color: darkMode ? "#ffffff !important" : "#666666 !important",
                              opacity: "1 !important",
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4)" : "rgba(0, 0, 0, 0.23)",
                            },
                            "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                              borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : "rgba(0, 0, 0, 0.23) !important",
                            }
                          }}
                        />
                        {loginSettingsEditMode ? (
                          <div className="settings-dialog-actions" style={{ marginTop: '20px' }}>
                            <Button
                              className="btn-success"
                              variant="contained"
                              onClick={handleLoginContentSave}
                              style={{ textTransform: 'none' }}
                            >
                              Save
                            </Button>
                            <Button
                              className="btn-cancel"
                              onClick={handleCloseLoginSettingsDialog}
                              style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                            >
                              Cancel
                            </Button>
                          </div>
                        ) : null}
                      </DialogContent>
                    </Dialog>

                    <Dialog open={logoDialogOpen} onClose={handleCloseLogoDialog} fullWidth maxWidth="sm" PaperProps={{ className: "settings-dialog-paper" }}>
                      <DialogTitle className="settings-dialog-title">
                        {logoEditMode ? "Edit Logo" : "View Logo"}
                      </DialogTitle>
                      <CloseIcon
                        className="settings-dialog-close"
                        onClick={handleCloseLogoDialog}
                      />
                      <DialogContent className="settings-dialog-content">
                        <Box sx={{ mt: 1, mb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                          {logoUrl ? (
                            <Box sx={{ position: 'relative', border: '1px solid #ccc', borderRadius: '4px', p: 1, backgroundColor: '#f9f9f9', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '120px' }}>
                              <img
                                src={logoUrl}
                                alt="System Logo"
                                style={{ maxHeight: '100px', maxWidth: '250px', objectFit: 'contain' }}
                              />
                              {logoEditMode && (
                                <Button
                                  size="small"
                                  color="error"
                                  variant="outlined"
                                  onClick={() => setLogoUrl("")}
                                  sx={{ position: 'absolute', top: 5, right: 5, minWidth: 'auto', p: '2px 6px' }}
                                >
                                  Remove
                                </Button>
                              )}
                            </Box>
                          ) : (
                            <Typography variant="body1" color="textSecondary" sx={{ py: 3 }}>No logo uploaded</Typography>
                          )}
                          {logoEditMode && (
                            <Button
                              variant="outlined"
                              component="label"
                              size="small"
                              sx={{ textTransform: 'none' }}
                            >
                              Upload Logo
                              <input
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleLogoUpload}
                              />
                            </Button>
                          )}
                        </Box>
                        {logoEditMode ? (
                          <div className="settings-dialog-actions" style={{ marginTop: '20px' }}>
                            <Button
                              className="btn-success"
                              variant="contained"
                              onClick={handleLogoSave}
                              style={{ textTransform: 'none' }}
                            >
                              Save
                            </Button>
                            <Button
                              className="btn-cancel"
                              onClick={handleCloseLogoDialog}
                              style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                            >
                              Cancel
                            </Button>
                          </div>
                        ) : null}
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                )}


              </div>
            </Grid>
          </div>
        }
      />
      <Footer />
      <Dialog open={calendarColorsDialogOpen} onClose={() => setCalendarColorsDialogOpen(false)} fullWidth maxWidth="md" PaperProps={{ className: "settings-dialog-paper" }}>
        <DialogTitle className="settings-dialog-title">
          {calendarColorsEditMode ? "Edit Calendar Event Colors" : "Current Calendar Event Colors"}
        </DialogTitle>
        <CloseIcon className="settings-dialog-close" onClick={() => setCalendarColorsDialogOpen(false)} />
        <DialogContent style={{ paddingTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Grid container spacing={2}>
            {Object.keys(calendarColors)
              .filter((catKey) => !catKey.startsWith("Leave - "))
              .map((catKey) => (
              <Grid item xs={6} key={catKey}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                  <span style={{ width: 160, fontWeight: 600 }}>{catKey}</span>
                  <input
                    type="color"
                    value={calendarColors[catKey] || '#000000'}
                    disabled={!calendarColorsEditMode}
                    onChange={e => handleCalendarColorChange(catKey, e.target.value)}
                    style={{ marginLeft: 10, marginRight: 10, width: 40, height: 30, border: 'none', background: 'none', cursor: calendarColorsEditMode ? 'pointer' : 'default' }}
                  />
                  <span style={{ color: darkMode ? "#ffffff" : "#000000", fontWeight: 'bold', marginLeft: 10 }}>{calendarColors[catKey]}</span>
                </div>
              </Grid>
            ))}
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              {calendarColorsEditMode ? (
                <div className="settings-dialog-actions">
                  <Button className="btn-success" variant="contained" color="primary" onClick={() => { handleCalendarColorsSave(); setCalendarColorsDialogOpen(false); }} style={{ textTransform: 'none', backgroundColor: "#036dda", color: "#fff" }}>Save</Button>
                  <Button
                    className="btn-cancel"
                    onClick={() => setCalendarColorsDialogOpen(false)}
                    style={{ color: darkMode ? "#ffffff" : "#000000", textTransform: 'none' }}
                  >
                    Cancel
                  </Button>
                </div>
              ) : null}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={iconPickerOpen} onClose={() => setIconPickerOpen(false)}>
      <DialogTitle className="settings-dialog-title">Select an Icon</DialogTitle>
        <DialogContent>
          <Suspense fallback={<div>Loading...</div>}>
            <IconPicker
              onSelect={handleIconChange}
              onCancel={() => setIconPickerOpen(false)}
            />
          </Suspense>
        </DialogContent>
      </Dialog>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default Settings;
